import React, { useState } from "react";
import { programRegionProgressData } from "../../../types/programRegionProgressData";
import { ChevronDown } from "lucide-react";

const RegionProgress: React.FC = () => {
  const data = programRegionProgressData["akses-layanan"];
  const [activeProvince, setActiveProvince] = useState<string | null>(null);

  return (
    <div className="mt-14">
      <h2 className="text-2xl font-bold text-gray-800 mb-6">
        Wilayah dengan Tingkat <span className="text-red-600">Kemiskinan</span> Tertinggi
      </h2>

      <div className="bg-gray-100 rounded-3xl p-8 space-y-6">
        {data.map((prov, index) => {
          const isOpen = activeProvince === prov.province;

          return (
            <div key={index} className="space-y-3">
              {/* PROVINSI */}
              <button onClick={() => setActiveProvince(isOpen ? null : prov.province)} className="w-full text-left">
                <div className="flex items-center justify-between mb-2 gap-3">
                  <span className="font-semibold text-gray-800">{prov.province}</span>

                  <div className="flex items-center gap-3">
                    <span className="text-sm text-gray-500">{prov.percentage} %</span>

                    <ChevronDown className={`w-4 h-4 text-gray-500 transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`} />
                  </div>
                </div>

                <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
                  <div className="bg-red-600 h-3 rounded-full transition-all duration-700" style={{ width: `${prov.percentage}%` }} />
                </div>
              </button>

              {/* LIST KOTA */}
              {isOpen && (
                <div className="ml-4 pl-4 border-l border-gray-300 space-y-2">
                  {prov.cities.map((city, i) => (
                    <div key={i} className="flex justify-between text-sm text-gray-700">
                      <span>{city.city}</span>
                      <span className="text-gray-500">{city.percentage.toLocaleString("id-ID")} Jiwa</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>

      <p className="text-xs text-gray-400 mt-4">*Data estimasi berbasis prioritas program dan wilayah intervensi.</p>
    </div>
  );
};

export default RegionProgress;
